// Customizable Area Start
import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import { Message } from "../../../framework/src/Message";
import { getErrorMessage } from "../../../components/src/CommonFunctions";
import moment from "moment";
import { loadStripe } from "@stripe/stripe-js";
export const configJSON = require("./config");
export const stripePromise = loadStripe(configJSON.stripeKey);

export interface Props {
  navigation: any;
  id: string;
}

interface S {
  plans: any;
  loading: boolean;
  isGettingPlans: boolean
  activeFilter: string;
  normalPlans: any;
  currentPlan: any;
  currentPlanData: any;
  planExpiryDate: string
  showSuccessAlert: boolean;
  alertMessage: string;
  subscriptionModal: boolean;
  pauseModal: boolean;
  selectedPlan: any;
  pauseReason: string;
  otherReason: string;
  reasonError: boolean;
  pausedAccount: any;
  isPaused: boolean;
  pauseConfirmationDialog: boolean;
  paymentModal: boolean;
  clientSecret: string;
  stripeForm: any;
  elementsKey: number;
}
interface SS {
  id: any;
}
export default class UpdatesubscriptionController extends BlockComponent<
  Props,
  S,
  SS
> {
  subscriptionPlansAPIID: any = "";
  getCurrentBuPlanAPIID: any = "";
  updateCurrentBuPlanAPIID: any = "";
  pauseAccountAPIID: any = "";
  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [getName(MessageEnum.RestAPIResponceMessage)];

    this.state = {
      plans: [],
      loading: false,
      isGettingPlans: false,
      activeFilter: "month",
      normalPlans: [],
      currentPlan: {},
      currentPlanData:[],
      planExpiryDate: "",
      showSuccessAlert: false,
      alertMessage: "Plan Updated Successfully! ",
      subscriptionModal: false,
      pauseModal: false,
      selectedPlan: [],
      pauseReason: "",
      otherReason: "",
      pausedAccount: {},
      isPaused: false,
      reasonError: false,
      pauseConfirmationDialog: false,
      paymentModal: false,
      clientSecret: "",
      stripeForm: {},
      elementsKey: 0
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  handleCurrentBuPlan(responseJson: any) {
    console.log("🔍 Updatesubscription API Response:", responseJson);
    console.log("📊 Raw Plans Data:", responseJson.data);
    
    // Check if products have plans
    const productsWithPlans = responseJson.data.filter((product: any) => 
      product.attributes.plans && product.attributes.plans.length > 0
    );
    
    console.log("📋 Products with plans:", productsWithPlans);
    console.log("📋 Products without plans:", responseJson.data.filter((product: any) => 
      !product.attributes.plans || product.attributes.plans.length === 0
    ));
    
    if (productsWithPlans.length === 0) {
      console.warn("⚠️ No products with plans found! All products have empty plans arrays.");
      // Show all products even if they don't have plans, for debugging
      this.setState({
        plans: responseJson.data,
        normalPlans: responseJson.data,
      });
    } else {
      // Filter plans by the current activeFilter (default is "month")
      const filteredPlans = this.filterData(responseJson.data, this.state.activeFilter);
      this.setState({
        plans: filteredPlans,
        normalPlans: responseJson.data,
      });
    }

    const account = responseJson.data.filter(
      (e: any) => e.attributes.name === "Essentials" ||
        e.attributes.name === "Standard" ||
        e.attributes.name === "Profssional" //Professional
    )[0];
    this.setState({ pausedAccount: account });
  }
  handlePauseReasonChange = (value: string) => {
    this.setState({ pauseReason: value, reasonError: false });
  };

  handleOtherReason = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = event.target
    this.setState({ otherReason: value, reasonError: false });
  };

  async receive(from: string, message: Message) {
    const messageType = getName(MessageEnum.RestAPIResponceMessage);

    if (messageType === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );
      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      if (apiRequestCallId === this.pauseAccountAPIID) {
        this.setState({ alertMessage: responseJson.message });
        this.setState({ showSuccessAlert: true });
        this.closePauseModal();
        this.closePauseConfirmationDialog()
        setTimeout(() => {
          this.setState({ showSuccessAlert: false });
        }, 2000);
      }

      if (apiRequestCallId === this.updateCurrentBuPlanAPIID) {
        const errorJson = message.getData(
          getName(MessageEnum.RestAPIResponceErrorMessage)
        );
        
        // Handle error cases
        if (errorJson || responseJson?.error || responseJson?.errors) {
          this.setState({ loading: false, isGettingPlans: false });
          let err = getErrorMessage(responseJson?.errors?.[0] || errorJson || responseJson?.error);
          this.setState({ alertMessage: err || "Subscription update failed" });
          this.setState({ showSuccessAlert: true });
          setTimeout(() => {
            this.setState({ showSuccessAlert: false });
          }, 2000);
          return;
        }

        // Check if client_secret is in the response (payment required)
        const clientSecret = responseJson?.client_secret 
          || responseJson?.data?.client_secret 
          || responseJson?.data?.attributes?.client_secret
          || responseJson?.attributes?.client_secret;

        if (clientSecret) {
          // Payment required - show payment modal
          this.setState({ 
            clientSecret: clientSecret,
            paymentModal: true,
            subscriptionModal: false
          });
        } else {
          // No payment required - update successful
          this.redirectPause()
          this.setState({ alertMessage: "Plan Updated Successfully! " });
          this.setState({ showSuccessAlert: true });
          this.closeFormModal();
          this.getCurrentBuPlan();
          setTimeout(() => {
            this.setState({ showSuccessAlert: false });
          }, 2000);
        }
      }

      if (responseJson.data) {
        this.setState({ loading: false });
        if (apiRequestCallId === this.subscriptionPlansAPIID) {
          this.handleCurrentBuPlan(responseJson);
        }

        if (apiRequestCallId === this.getCurrentBuPlanAPIID) {
          this.handlePause(responseJson)
          const planExpiryDate = moment(responseJson.data.attributes.period_end).format('MM/DD/YYYY')
          this.setState({ currentPlan: responseJson.data.attributes.plan.id, planExpiryDate, isGettingPlans: false });
          this.setState({currentPlanData: responseJson.data})
        }
      } else if (responseJson.errors) {
        this.setState({ loading: false, isGettingPlans: false });
        let err = getErrorMessage(responseJson.errors[0]);
        // alert(err);
      }
    }
  }

  handlePause(responseJson:any){
    if (responseJson.data.attributes.status === "paused") {
      this.setState({ isPaused: true });
    }
  }

  redirectPause(){
    if (this.state.isPaused) {
      window.location.href = "/Dashoard";
    }
  }

  async componentDidMount(): Promise<void> {
    this.getuserSubscriptionPlans();
    this.getCurrentBuPlan();
  }

  closeFormModal = () => {
    this.setState({ subscriptionModal: false });
  };
  openFormModal = () => {
    this.setState({ subscriptionModal: true });
  };

  closePauseModal = () => {
    this.setState({ pauseModal: false, otherReason: "", pauseReason: "" });
  };
  openPauseModal = () => {
    this.setState({ pauseModal: true });
  };

  openPauseConfirmationDialog = () => {
    this.setState({ pauseConfirmationDialog: true })
  }

  closePauseConfirmationDialog = () => {
    this.setState({ pauseConfirmationDialog: false })
  }

  closePaymentModal = () => {
    this.setState({ 
      paymentModal: false, 
      clientSecret: "",
      stripeForm: {},
      elementsKey: this.state.elementsKey + 1
    });
  }

  openPaymentModal = () => {
    this.setState({ paymentModal: true });
  }

  handleStripeFormReady = (stripe: any, elements: any) => {
    this.setState({
      stripeForm: { stripe: stripe, elements: elements }
    });
  }

  handlePaymentSubmit = async () => {
    if (!this.state.stripeForm.stripe || !this.state.stripeForm.elements) {
      console.error("Stripe or Elements not loaded.");
      return;
    }

    try {
      const matchResult = window.location.href.match(/^(https?:\/\/[a-z0-9\:\-.]+)\//);
      const dynamicBaseUrl = matchResult ? matchResult[1] : '';
      const returnUrl = `${dynamicBaseUrl}/settings`;

      const result = await this.state.stripeForm.stripe.confirmPayment({
        elements: this.state.stripeForm.elements,
        clientSecret: this.state.clientSecret,
        confirmParams: {
          return_url: returnUrl,
        },
        redirect: "if_required"
      });

      if (result.error) {
        console.error("Payment error:", result.error.message);
        this.setState({ 
          alertMessage: result.error.message || "Payment failed. Please try again.",
          showSuccessAlert: true 
        });
        setTimeout(() => {
          this.setState({ showSuccessAlert: false });
        }, 3000);
      } else {
        // Payment successful
        this.handlePaymentSuccess();
      }
    } catch (error) {
      console.error("Error confirming payment:", error);
      this.setState({ 
        alertMessage: "An error occurred during payment. Please try again.",
        showSuccessAlert: true 
      });
      setTimeout(() => {
        this.setState({ showSuccessAlert: false });
      }, 3000);
    }
  }

  handlePaymentSuccess = () => {
    this.closePaymentModal();
    this.closeFormModal();
    this.redirectPause();
    this.setState({ alertMessage: "Plan Updated Successfully! " });
    this.setState({ showSuccessAlert: true });
    this.getCurrentBuPlan();
    setTimeout(() => {
      this.setState({ showSuccessAlert: false });
    }, 2000);
  }

  platformToggling(id: any) {
    const newData = this.state.plans.map((x: any) => {
      if (x.attributes.id === id) {
        x.isPlatformManagement = !x.isPlatformManagement;
      } else {
        x.isPlatformManagement = false;
      }
      return x;
    });
    this.setState({ plans: newData });
  }

  handleFilter(type: string) {
    // Filter plans by the selected interval
    const filteredPlans = this.filterData(this.state.normalPlans, type);
    this.setState({ activeFilter: type, plans: filteredPlans });
    const account = filteredPlans.filter(
      (e: any) =>  e.attributes.name === "Essentials" ||
        e.attributes.name === "Standard" ||
        e.attributes.name === "Profssional" //Professional
    )[0];
    this.setState({ pausedAccount: account });
  }

  filterData(data: any, interval: string) {
    return data
      .map((product: any) => {
        // Handle products with no plans or empty plans array
        if (!product.attributes.plans || product.attributes.plans.length === 0) {
          return {
            ...product,
            attributes: {
              ...product.attributes,
              plans: [], // Keep empty array for products without plans
            },
          };
        }
        
        const filteredPlans = product.attributes.plans.filter(
          (plan: any) => plan.interval === interval
        );
        return {
          ...product,
          attributes: {
            ...product.attributes,
            plans: filteredPlans,
          },
        };
      })
      .filter((product: any) => {
        // Show products that have plans with the selected interval
        return product.attributes.plans && product.attributes.plans.length > 0;
      });
  }

  getuserSubscriptionPlans() {
    const headerData = {
      "Content-Type": configJSON.signupEmailApiContentType,
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.subscriptionPlansAPIID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.settingsSubscriptionPlansEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  getCurrentBuPlan() {
    this.setState({ isGettingPlans: true })
    const headerData = {
      "Content-Type": configJSON.signupEmailApiContentType,
      Token: localStorage.getItem("authToken"),
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getCurrentBuPlanAPIID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getCurrentBuPlanEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "GET"
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  updateBuPlan(plan: any) {
    const headerData = {
      "Content-Type": configJSON.contentType,
      Token: localStorage.getItem("authToken"),
    };
    const platform_management = !!plan?.attributes?.isPlatformManagement;
    const attrs = {
      stripe_price_id: plan.attributes.plans[0].stripe_plan_id,
      plan_id: plan.attributes.plans[0].id,
      platform_management: platform_management,
    };

    const httpBody = {
      subscription: attrs,
    };

    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateCurrentBuPlanAPIID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.updateCurrentBuPlanEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PUT"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  }

  handlePauseSubscription = () => {
    const { pauseReason, otherReason } = this.state
    const reason = pauseReason === "other" ? otherReason : pauseReason
    if(!reason) {
      this.setState({ reasonError: true })
      return
    }
    this.openPauseConfirmationDialog()
  }

  pauseBuAccout = () => {
    const headerData = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("authToken"),
    };
    const { pauseReason, otherReason } = this.state;
    const reason = pauseReason === "other" ? otherReason : pauseReason;
    let data = {
      reason: reason,
    };
    let requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.pauseAccountAPIID = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headerData)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.pauseBuAccountEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "POST"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(data)
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
    return requestMessage.messageId;
  };
}

// Customizable Area End
